export const API_URL='https://buscador.unotv.com/'
export const PATHURLDOMAIN='https://www.unotv.com'
export const API_LOCAL='https://cdn.unotv.com/json/buscador_'
export const AMBIENTE='.unotv.com' 
export const PAGESIZE=20;
export const MAX_RETRIES=3;



// export const API_URL="https://dev-buscador.unotv.com/";
// export const PATHURLDOMAIN="https://local.uno.com/";
// export const API_LOCAL="https://dev-cdn.unotv.com/json/buscador_";
// export const PAGESIZE=20;
// export const MAX_RETRIES = 3; // Número máximo de reintentos